module.exports = __webpack_public_path__ + "static/media/camarones.830fff77.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/video/camarones.mp4
// module id = 35
// module chunks = 0